import { FC } from 'react';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { AttributeWithValues } from '@/types/creator';
import { creatorActions } from '@/store/slices/creatorSlice';
import { AttributeValue } from '@/api/AttributeValueApi';
import { DisplayAttribute } from './DisplayAttribute';

interface Props {
	preparedAttribute: AttributeWithValues;
}

export const Attribute: FC<Props> = ({ preparedAttribute }) => {
	const dispatch = useTypedDispatch();

	const { selectedAttributeValues } = useTypedSelector((app) => app.creator);

	const handleClick = (value: AttributeValue) => () => {
		dispatch(
			creatorActions.selectAttributeValue({
				attributeId: preparedAttribute.id,
				value,
			})
		);
	};

	const selectedValue = selectedAttributeValues[preparedAttribute.id];

	return (
		<DisplayAttribute
			preparedAttribute={preparedAttribute}
			selectedValue={selectedValue}
			handleClick={handleClick}
		/>
	);
};
